import _ from 'lodash'
import namesFilter from './namesFilter'
import values from './values'

export default (rows, names) => (
  _.sum(values(_.filter(rows, namesFilter(names))))
)
